<style>
  #MyListMenu li{
    list-style: none;
  }
  .Lvl2{
    margin: 10px 20px;
  }
</style>
<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">فرم ثبت اطلاعات نماینده جدید </h5>


      <form [formGroup]="FormAddRepresentative" (submit)="SubmitRepresentative()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6" >
              <label for="exampleInputEmail1">نام کاربری</label>
              <div class="row">
                <div class="form-group col-md-8">
                  <input formControlName="Username" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
              <small *ngIf="!get_Form_Username().valid && get_Form_Username().touched" class="form-text text-muted MyErrorRedColor">نام کاربری را وارد نمائید.</small>
                </div>
                <div class="form-group col-md-4">
                  <input value="{{PreUserName}}" disabled style="font-weight: bolder;direction: ltr;"  type="text" class="form-control"  >
                </div>
              </div>

          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">رمز عبور</label>
            <input formControlName="Password" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Password().valid && get_Form_Password().touched" class="form-text text-muted MyErrorRedColor">رمز عبور را وارد نمائید. (حداقل 8 کاراکتر - از حروف بزرگ و کوچک ، عدد و سمبل استفاده شود)</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6" >
              <label for="exampleInputEmail1">نام</label>
              <input formControlName="FName" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
              <small *ngIf="!get_Form_FName().valid && get_Form_FName().touched" class="form-text text-muted MyErrorRedColor">نام را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">نام خانوادگی</label>
            <input formControlName="LName" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_LName().valid && get_Form_LName().touched" class="form-text text-muted MyErrorRedColor">نام خانوادگی را وارد نمائید. </small>
          </div>
        </div>
        <br/>
        <hr/>
        <br/>
        <h5 class="card-title">دسترسی به منو های سامانه</h5>
        <div style="margin: 50px;">

          <ul id="MyListMenu">
              <ng-container *ngFor="let lvl1 of Data_List_Menu">
                {{lvl1.title}}
                <li *ngFor="let item of lvl1.child">
                  <input  type="checkbox" (change)="Data_List_Menu_Change(item)" [checked]="item.selected" [ngClass]="{'Lvl2':item.parent>0}" /> {{item.title}}
                </li>
              </ng-container>
          </ul>

        </div>

        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
        <button *ngIf="!InProccessing" type="submit" [disabled]="!FormAddRepresentative.valid" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
        <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-left: 5px;"><i class="fa fa-times-rectangle" ></i> لغو </button>
        <button routerLink="/Representative" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>
      </form>
  </div>
</div>
